import styled from 'styled-components';

export const Header = styled.header`
    @media screen and ( min-width: 0px ) {
        position: sticky;
        top: 0;
        left: 0;
        z-index: 1000;
        background-color: var(--white);
        display: flex;
        align-items: center;
        width: 100%;
        height: 56px;
        padding: 0 1em;
        box-shadow: 0px 3px 3px 0px rgba( 0, 0, 0, .1 );

        button {
            background: none;
            border: none;
            outline: none;
        }

        img.logo {
            display: block;
            width: 70px;
            height: 15px; 
        }    

        h1 {
            font-size: 1.125em;
            font-weight: 600;
            margin: 0;
            margin-left: 1em;
        }
    }

    @media screen and ( min-width: 992px ) {
        height: 90px;
        display: flex;
        justify-content: space-between;

        img.logo  {
            width: 190px;
            height: 40px;
        }        

        h1 {
            font-size: 1.425em;
        }

        .logout {
            color: var(--secundary-color);
            font-weight: bold;
            font-size: 18px;
            text-decoration: underline;
        }
    }
`